import React from 'react';
import { Button, Modal, ModalProps } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { createModal } from 'react-modal-promise';

/*
   Usa as:
    const res = await promiseModalDialog({
        title: 'Διαγραφή Εγγραφής Αρχείου',
        text: 'Είστε σίγουροι ότι θέλετε να διαγράψετε το Αρχείο;',
      });
*/

type Props = {
  readonly open: boolean;
  readonly close: (result: boolean) => void;
  readonly title: string;
  /** body of dialog */
  readonly text: string; // | React.ReactNode;
  /** accept text */
  readonly acceptText?: string;
  /** deny text */
  readonly denyText?: string;
} & ModalProps;

type PromiseModalDialogOptions = {
  readonly title: string;
  /** body of dialog */
  readonly text: string; // | React.ReactNode;
  /** accept text */
  readonly acceptText?: string;
  /** deny text */
  readonly denyText?: string;
} & ModalProps;

const ModalDialog = ({ open, close, title, text, acceptText, denyText }: Props) => {
  const { t, i18n } = useTranslation();
  acceptText = acceptText ? acceptText : i18n.language === 'gr' ? t('ΝΑΙ') : t('Yes');
  denyText = denyText ? denyText : i18n.language === 'gr' ? t('ΟΧΙ') : t('No');
  return (
    <>
      <Modal show={open} centered backdrop="static">
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body dangerouslySetInnerHTML={{ __html: text }} />
        <Modal.Footer>
          <Button
            size="sm"
            className="px-3"
            style={{ minWidth: '5rem' }}
            variant="primary"
            onClick={() => close(true)}
          >
            &nbsp;{acceptText}&nbsp;
          </Button>
          <Button
            size="sm"
            className="px-3"
            style={{ minWidth: '5rem' }}
            variant="danger"
            onClick={() => close(false)}
          >
            &nbsp;{denyText}&nbsp;
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const promiseModalDialog = (createModal as any)(ModalDialog as React.ComponentType<any>);

export default promiseModalDialog;
